import React,{} from "react";

import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";


const StudentCardProgress = (props) => {
  return (
    <Box sx={{ py: 1}}>
      <Grid container sx={{ flexDirection: 'row', justifyContent: 'flex-start'}}>
        <Grid item xs={12}>
          <Box sx={{ position: "relative" }}>
            <LinearProgress
              variant="determinate"
              color="success"
              {...props}
              sx={{ height: "24px", borderRadius: 25, border: 1, borderColor: '#CCC',backgroundColor: '#FFFFFF','@media (min-width: 1636px)': {height: "34px"}}}
            />
            <Box sx={{ minWidth: 35, position: "absolute", top: 2, right: 10 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: "1rem", fontWeight: "bold", color: '#A9A9A9','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
              >{`${Math.round(props.value)}%`}</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default StudentCardProgress;